import CopyToClipboard from 'react-copy-to-clipboard';
import { IconButton } from 'src/components/atoms';
import { SlackIcon } from 'src/components/icons/SlackIcon';
import { env } from 'src/utils/env';
import { DateFormats, formatDate } from 'src/utils/time';
import {
  BorderlessLinkButton,
  ButtonText,
  LinkButtonWithCopyContainer,
  WorkspaceName,
} from './AddToSlackButton.styles';

export const getInstallLink = (teamId: string) =>
  `${env.REACT_APP_SLACK_REPORTING_URL}/install?team=${teamId}`;

export const AddToSlackButton = ({
  workspaceName,
  teamId,
  installed,
  installedAt,
  onCopy,
}: {
  workspaceName: string;
  teamId: string;
  installed: boolean;
  installedAt?: string;
  onCopy: () => void;
}) => {
  const formattedDate = installedAt
    ? formatDate(installedAt, DateFormats.DAY_MONTH_YEAR)
    : '';

  const buttonSize = 'medium';
  const buttonText = installed
    ? `Installed on ${formattedDate}`
    : 'Install to Slack';

  const iconSize = '24px';
  const iconName = 'uil-copy';

  return (
    <LinkButtonWithCopyContainer>
      <BorderlessLinkButton
        variant="secondary"
        size={buttonSize}
        disabled={installed}
        width="160px"
        to={getInstallLink(teamId)}
      >
        <ButtonText>
          <WorkspaceName>{workspaceName}</WorkspaceName>
          <br />
          <span>{buttonText}</span>
        </ButtonText>
        <SlackIcon
          size={20}
          style={{
            opacity: installed ? 0.3 : 1,
            marginRight: 0,
            marginLeft: 10,
          }}
        />
      </BorderlessLinkButton>

      {installed ? (
        <IconButton
          size="medium"
          variant="secondary"
          iconName={iconName}
          fontSize={iconSize}
          disabled
          noBorder
        >
          Copy
        </IconButton>
      ) : (
        <CopyToClipboard text={getInstallLink(teamId)}>
          <IconButton
            size="medium"
            variant="secondary"
            iconName={iconName}
            fontSize={iconSize}
            noBorder
            onClick={onCopy}
          >
            Copy
          </IconButton>
        </CopyToClipboard>
      )}
    </LinkButtonWithCopyContainer>
  );
};
